import { buildSpringPageParams } from 'shared/api/list-query-params';
import { cmsHttp } from 'shared/api/mfe-axios';
const LIST_URL = 'api/cards';
const CARD_URL = 'api/cards';
export const cardQueryKeys = {
    all: ['cms', 'cards'],
    lists: () => [...cardQueryKeys.all, 'list'],
    list: (params) => [...cardQueryKeys.lists(), params],
    details: () => [...cardQueryKeys.all, 'detail'],
    detail: (id) => [...cardQueryKeys.details(), id],
    lifecycle: (id) => [...cardQueryKeys.all, 'lifecycle', id],
};
export async function fetchCardsList(params) {
    const res = await cmsHttp().get(LIST_URL, {
        params: buildSpringPageParams(params),
    });
    const body = res.data;
    const list = Array.isArray(body) ? body : body?.content ?? [];
    const countHeader = res.headers?.['x-total-count'];
    const total = countHeader !== undefined && countHeader !== '' ? parseInt(String(countHeader), 10) : list.length;
    return {
        cards: list,
        totalItems: Number.isNaN(total) ? list.length : total,
    };
}
export async function fetchCard(id) {
    const res = await cmsHttp().get(`${CARD_URL}/${id}`);
    return res.data;
}
export async function deleteCardRequest(id) {
    await cmsHttp().delete(`${CARD_URL}/${id}`);
}
export async function fetchCardLifecycleEvents(cardId) {
    const res = await cmsHttp().get(`api/card-lifecycle-events/card/${cardId}`);
    const data = res.data;
    return Array.isArray(data) ? data : [];
}
export async function suspendCardRequest(id, reason) {
    const res = await cmsHttp().post(`api/${id}/suspend`, undefined, {
        params: { reason },
    });
    return res.data;
}
export async function unsuspendCardRequest(id, reason) {
    const res = await cmsHttp().post(`api/${id}/unsuspend`, undefined, {
        params: reason?.trim() ? { reason: reason.trim() } : undefined,
    });
    return res.data;
}
export async function hotlistCardRequest(id, reason) {
    const res = await cmsHttp().post(`api/${id}/hotlisted`, undefined, {
        params: { reason },
    });
    return res.data;
}
